import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class FileService {
  constructor(private readonly http: HttpClient) {}

  downloadPdf(fileUrl: string) {
    return this.http.get(`${environment.baseUrl}${fileUrl}`, { responseType: 'blob' });
  }
}
